/*!

=========================================================
* Argon Dashboard PRO Angular - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-angular
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { applyRuntimeConfig } from './runtime-config';

if (environment.production) {
  enableProdMode();
}

// The URL settings a deployment may replace, matching the keys the fleet
// renders into runtime-config.json. Nothing else can be overridden.
const RUNTIME_URL_SETTINGS = ['restApiUrl', 'clientDashboardUrl'];

// Before Sentry and bootstrap, so both read the deployment's settings.
applyRuntimeConfig(environment, RUNTIME_URL_SETTINGS)
  .then(() => {
    Sentry.init({
        dsn: environment.glitchTipDsn,
        environment: environment.production ? 'production' : 'development',
        enabled: !!environment.glitchTipDsn
    });
    return platformBrowserDynamic().bootstrapModule(AppModule);
  })
  .catch(err => console.error(err));
